import { type HttpGet, buildQueryString } from '@/shared/infra/http'
import type { LoadRequiredDocumentNames } from '@/shared/domain'

type WaiverListResponse = { waivers: { id: string; name: string }[] }

const MAX_REQUIRED_DOCUMENTS = 100

export class EdgeLoadRequiredDocumentNamesRepository {
  constructor(private readonly http: HttpGet) {}

  execute: LoadRequiredDocumentNames = async ({ orgId, orgType }) => {
    const query = buildQueryString({
      orgId,
      orgType,
      status: 'active',
      required: true,
      limit: MAX_REQUIRED_DOCUMENTS,
    })
    const response = await this.http.get<WaiverListResponse>({ url: `/waivers${query}` })
    return Object.fromEntries(response.waivers.map((waiver) => [waiver.id, waiver.name]))
  }
}
